// extracted by mini-css-extract-plugin
export default {"root":"ViewSubheader_root__FgGio"};